function H_u_OZE(){
    
    return(
            <div>
                <h1 align="center" style={{ textAlign: "center", color: "black" }}>
                    Hodnotenie účinnosti OZE
                </h1>
                <hr style={{ color: "#999999", height: "5px" }} />
                <p align="left"><strong>Učebná osnova</strong></p>
                <ol>
                    <li>Úvod, základné pojmy.</li>
                    <li>Hodnotenie účinnosti jednotlivých typov fotovoltických panelov.</li>
                    <li>Metodika hodnotenia účinnosti fotovoltických systémov.</li>
                    <li>Hodnotenie účinnosti plochých kolektorov.</li>
                    <li>Hodnotenie účinnosti trubicových kolektorov a parabolických solárnych koncentrátorov.</li>
                    <li>Hodnotenie účinnosti termických systémov.</li>
                    <li>Stanovovanie účinnosti pri využití vodnej energie, Hodnotenie účinnosti veternej energie využitím veterných turbín.</li>
                    <li>Hodnotenie účinnosti biomasy ako zdroja energie.</li>
                    <li>Hodnotenie výhrevnosti biomasy.</li>
                    <li>Stanovenie vlhkosti drevnej štiepky.</li>
                    <li>Využitie termovízie pri stanovovaní účinnosti OZE, Trendy v oblasti hodnotenia a stanovovania účinnosti OZE.</li>
                </ol>
                
                <p align="left"><strong>Úlohy:</strong></p>
                <p align="left">• Vypracovať hodnotenie účinnosti vybraného objektu podľa témy ZP.</p>
                <p align="left">• Vykonať laboratórne meranie vlhkosti biomasy a vypracovať a odovzdať protokoly z praktických meraní.</p>
                <p align="left">• Vypracovať a odovzdať zadania.</p>
                <p align="left"><strong>Prednášky:</strong></p>
                <p align="left">Podľa informačného listu v systéme MAIS</p>
                <p align="left">
                    <a href="https://www.asb.sk/stavebnictvo/technicke-zariadenia-budov/energie/akumulacia-tepelnej-energie-v-solarnych-systemoch" target="_blank">
                    Akumulácia tepelnej energie v solárnych systémoch
                    </a>
                </p>
                <p align="left">
                    <a href="https://www.asb.sk/stavebnictvo/technicke-zariadenia-budov/solarne-kolektory/termicke-slnecne-kolektory-a-tepelne-cerpadla" target="_blank">
                    Termické slnečné kolektory a tepelné čerpadlá
                    </a>
                </p>
                <p align="left">Výhrevnosť plynných palív&nbsp;
                    <a title="Vlastnosti plynných palív" target="_blank" href="tabulky/vyhrplyn.htm">tabuľka</a> (
                    <a target="_blank" href="tabulky/vyhrplyn.doc">doc</a>)
                </p>
                <p align="left"><strong style={{ color: "#006633" }}>Zadania:</strong></p>
                <p align="left">
                    <a href="huoze/z1.pdf" target="_blank">Zadanie č.1 </a>
                </p>
                <p align="left">
                    Zadanie č.2 &nbsp;
                    <a href="huoze/z2.htm" target="_blank">z2.htm</a>&nbsp;&nbsp;&nbsp;
                    <a href="huoze/z2.doc" target="_blank">z2.doc</a>
                </p>

                <h3>Podmienky ukončenia predmetu:</h3>
                <p>
                    <i style={{ color: "#852C39", fontSize: "16px" }}>
                    Spôsob hodnotenia a skončenia štúdia predmetu:
                    </i>{" "}
                    <strong>Klasifikovaný zápočet</strong>
                </p>
                <p>Kontrolovaná účasť na výpočtových cvičeniach a laboratórnych prácach. Ospravedlnená a nahradená neúčasť max.2 hod.</p>
                <p>Vypracovanie a odovzdanie protokolov a zadaní.</p>
                <p>
                    Záverečné hodnotenie (ZH): Študent prospeje v ZH a úspešne vykoná skúšku, keď splní podmienku získať <strong>min. 51%</strong> zo 100%.
                </p>
                <p>
                    Celkové hodnotenie: CH je suma hodnotení získaných študentom za hodnotené obdobie. Celkový výsledok sa stanoví v súlade s vnútornými predpismi TUKE.
                    (študijný poriadok, vnútorný predpis zásady doktorandského štúdia)
                </p>


                <p><strong>LITERATÚRA:</strong></p>
                <ul>
                    <li>Matuška, T.: Solární zařízení v příkladech. 1. vyd. Praha : Grada, 2013.</li>
                    <li>Dvořak, L.: Zdroje a přeměny energie. ES ČVUT, Praha, 1990, 1. vyd.</li>
                    <li>Kelnovčanová, A., Imriš, I.: Zdroje a premeny energie. MANACON, Prešov, 2006</li>
                    <li>Štibraný, P.: Veterná energetika. SAV, Bratislava, 1. vyd., 2000.</li>
                    <li>Kudelas, D., Rybár, R., Cehlár, M,: Energia vetra, prírodné, technické a ekonomické podmienky jej využitia. 1. vyd. Košice : TU, 2009</li>
                    <li>Cihelka, J: Solární tepelná technika. Praha : Malina, 1994.</li>
                    <li>Quaschning, V.: Obnovitelné zdroje energií. 1. vyd. Praha : Grada, 2010</li>
                    <li>Cenek, M. a kol.: Obnovitelné zdroje energie. FCC PUBLIC, s.r.o., Praha, 1994</li>
                    <li>Peťková, V., Svoboda J.: Termodiagnostika. VIENALA, 2016</li>
                    <li>Šimko, M., Chupáč, M.: Termovízia a jej využitie v praxi. EDIS ŽU v Žiline, 2007, ISBN 978-80-8070-654-8</li>
                    <li>Jandačka, J., Malcho, M., Mikulík, M.: Biomasa ako zdroj energie. Potenciál, druhy, bilancie a vlastnosti palív. GEORG, Žilina, 2006</li>
                    <li>Jandačka, J., Malcho, M.: Biomasa ako zdroj energie. GEORG, Žilina, 2007</li>
                    <li>Petráš, D. a kol.: Obnoviteľné zdroje energie pre nízkoteplotné systémy. JAGA GROUP, s.r.o., Bratislava, 2009, ISBN 978-80-8076-075-5</li>
                    <li>MacKay, David J.C.: Obnoviteľné zdroje energie-s chladnou hlavou. UIT Cambridge Ltd., 2008, preklad SIEA, 2015 [on-line]</li>
                    <li><a href='https://mais.tuke.sk/index.php' target='_blank' className="top style2 style4"/></li>
                    <li>Ďalšie informácie v MAIS-e</li>
                </ul>
            </div>
    );
};

export default H_u_OZE;